<template>
    <transition name="modal-fade">
        <div class="modal-backdrop" v-bind:class="className">
            <div class="modal-overlay" @click="back()"></div>
            <div class="modal">
                <article v-if="resource">

                    <header>
                        <figure>
                          <img :src="$iconFolder + 'template.svg'"/>
                        </figure>
                        <div>
                            <span class="breadcrumb">
                                Profile <i class="icon icon-icon_arrow-right"></i> Edit
                            </span>
                            <h1>{{ resource.name ? resource.name : 'Nouveau' }}</h1>
                        </div>
                        <div class="spacer"></div>
                        <div class="buttons">
                            <button @click="back()" class="bt-back"><span><i class="icon icon-icon_close"></i></span></button>
                            <button @click="submit()" class="bt-primary bt-save"><span><i class="icon icon-icon_tick"></i></span></button>
                        </div>
                     </header>

                    <main>

                      <languages :translations="resource.translations" :localesLoaded="localesLoaded" :locales="locales" v-model="locale"></languages>

                      <tabs :options="{ useUrlFragment: false }">
                            <tab name="Information">

                              <fieldset>
                                <h3>Détail</h3>
                                <p class="headline"></p>

                                <form-scopes label='Scopes' v-model="resource"></form-scopes>

                                <form-toggle label="Par défaut" v-model="resource.is_default"></form-toggle>

                                <div class="form-multilang" v-if="localesLoaded" :class="locale">
                                  <div v-for="client in locales" v-show="client.id == locale || locale == 'all'">
                                    <form-text :translate-key="'name'" :translations="resource.translations" :lang="client.id" :label="'Nom'" v-model="resource.translations[client.id].name" required="true"></form-text>
                                  </div>
                                </div>

                                <div class="form-multilang" v-if="localesLoaded" :class="locale">
                                  <div v-for="client in locales" v-show="client.id == locale || locale == 'all'">
                                    <form-text :translate-key="'description'" :translations="resource.translations" :lang="client.id" :label="'Description'" v-model="resource.translations[client.id].description" required="false"></form-text>
                                  </div>
                                </div>

                                <div class="form-multilang" v-if="localesLoaded" :class="locale">
                                  <div v-for="client in locales" v-show="client.id == locale || locale == 'all'">
                                    <form-file :translate-key="'picture_id'" :translations="resource.translations" label='PDF' :lang="client.id" v-model="resource.translations[client.id].picture_id" width="200"></form-file>
                                  </div>
                                </div>


                              </fieldset>

                            </tab>
                        </tabs>

                    </main>
                </article>

            </div>
        </div>
    </transition>
</template>
<script>

    import PdfTemplateService from './PdfTemplateService.js';
    import Edit from '../../../layouts/Edit.vue';


    export default {
        extends: Edit,
        components: {
        },
        data () {
            return {
                resource: {
                },
                isLoading: false,
            }
        },
        mounted: function(){
        },
        methods:{
            resourceLoaded: function(){
                this.setTranslations(['name','description','picture_id']);
                this.resource.config = this.resource.config;
                this.initialize()
            },
            beforeUpdate: function(Resource){
                return true;
            },
            getResource: function(){
                return PdfTemplateService
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/config/pdf-template/Edit.vue